import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import {getCountries} from '../../utils/i18n';

/**
 * A wrapper for a ReactSelect component that picks countries.  Takes all the normal ReactSelect params plus some customer specific ones.
 */
export default class CountrySelect extends React.Component {
  static propTypes = {
    clearable: PropTypes.bool,
    filter: PropTypes.func, // Match countries that
    getOptionLabel: PropTypes.func, // ReactSelect prop to get the display label for a country.  Default (c)=>c.label
    getOptionValue: PropTypes.func,  // Use if you need a different format than the 2-letter code (i.e. stripe code or 3 character abbreviation).  Default (c)=>c.code
    onChange: PropTypes.func // Callback for when the country changes.  Takes {label, value} as a parameter were both are the result of getOptionLabel and getOptionValue respectively
  };

  static defaultProps = {
    clearable: true,
    filter: ()=>true,
    getOptionLabel: (c)=>c.label,
    getOptionValue: (c)=>c.code
  };

  filterAndMapOptions() {
    const {
      clearable,
      filter,
      getOptionLabel,
      getOptionValue
    } = this.props;

    const countries = getCountries()
      .filter(filter)
      .map((c) => ({
        label: getOptionLabel(c),
        value: getOptionValue(c)
      }));

    if (clearable) {
      countries.unshift({ label: '', value: '' });
    }

    return countries;
  }

  render() {
    return <Select
      options={this.filterAndMapOptions()}
      {...this.props}
    />;
  }
}
